var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "footerNew2020" } }, [
    _c("div", { attrs: { id: "footerFirstContainer" } }, [
      _c("div", { staticClass: "footerSectionWrapper" }, [
        _c("div", { staticClass: "footerColumn fCol1" }, [
          _c("div", { staticClass: "footerColumnWrapper" }, [
            !this.$root.isMedUK && !this.$root.isNutriverse
              ? _c("div", [
                  _vm._m(0),
                  _c(
                    "p",
                    { staticClass: "companyDesc-text" },
                    [
                      _c("webmessage", {
                        attrs: {
                          text: this.$root.language
                            .wsm_Footer2020_companyDescription,
                          searchKey: "wsm_Footer2020_companyDescription",
                        },
                      }),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _c("div", [
              _c(
                "h4",
                { staticClass: "footer-infoHeader" },
                [
                  _c("webmessage", {
                    attrs: {
                      text: this.$root.language.wsm_Address,
                      searchKey: "wsm_Address",
                    },
                  }),
                  _vm._v(" "),
                  _c("i", { staticClass: "fas fa-map-marker-alt" }),
                ],
                1
              ),
              this.$root.isThai
                ? _c("p", {
                    domProps: {
                      innerHTML: _vm._s(
                        this.$root.language.wsm_Thai_en_Footer2020_address
                      ),
                    },
                  })
                : _c(
                    "p",
                    [
                      _c("webmessage", {
                        attrs: {
                          text: this.$root.language.wsm_Footer2020_address,
                          searchKey: "wsm_Footer2020_address",
                        },
                      }),
                    ],
                    1
                  ),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "footerColumn fCol2" }, [
          this.$root.isThai
            ? _c("div", { staticClass: "footerColumnWrapper" }, [
                _c("div", [
                  _c(
                    "h4",
                    [
                      _c("webmessage", {
                        attrs: {
                          text: this.$root.language.wsm_Thai_en_OpeningHours,
                          searchKey: "wsm_Thai_en_OpeningHours",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "p",
                    [
                      _c("webmessage", {
                        attrs: {
                          text: this.$root.language
                            .wsm_Thai_en_phoneOpeningHoursMonToThurs,
                          searchKey: "wsm_Thai_en_phoneOpeningHoursMonToThurs",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "p",
                    [
                      _c("webmessage", {
                        attrs: {
                          text: this.$root.language
                            .wsm_Thai_en_phoneOpeningHoursFriday,
                          searchKey: "wsm_Thai_en_phoneOpeningHoursFriday",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "h2",
                    [
                      _c("webmessage", {
                        attrs: {
                          text: this.$root.language
                            .wsm_Thai_en_Footer2020_phone,
                          searchKey: "wsm_Thai_en_Footer2020_phone",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _c(
                  "div",
                  { staticClass: "soMeWrapper" },
                  [
                    this.$root.facebookLink != undefined &&
                    this.$root.facebookLink != ""
                      ? _c(
                          "a",
                          {
                            attrs: {
                              href: this.$root.facebookLink,
                              target: "_blank",
                            },
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: "/CKFinderJava/userfiles/images/general/SOME/Facebook.svg",
                                alt: "Facebook/Meta",
                              },
                            }),
                          ]
                        )
                      : _vm._e(),
                    this.$root.channel != "" || this.$root.channel != undefined
                      ? _c(
                          "a",
                          {
                            attrs: {
                              href:
                                "https://www.youtube.com/channel/" +
                                this.$root.channel,
                              target: "_blank",
                            },
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: "/CKFinderJava/userfiles/images/general/SOME/yt_icon_mono_light.svg",
                                alt: "YouTube",
                              },
                            }),
                          ]
                        )
                      : _vm._e(),
                    this.$root.linkedin != "" &&
                    this.$root.linkedin != undefined
                      ? _c(
                          "a",
                          {
                            attrs: {
                              href: this.$root.linkedin,
                              target: "_blank",
                            },
                          },
                          [
                            _c("img", {
                              staticClass: "linkedIn",
                              attrs: {
                                src: "/CKFinderJava/userfiles/images/general/SOME/LI-In-Bug-black-v2.svg",
                                alt: "LinkedIn",
                              },
                            }),
                          ]
                        )
                      : _vm._e(),
                    this.$root.twitterLink != undefined &&
                    this.$root.twitterLink != ""
                      ? _c(
                          "a",
                          {
                            attrs: {
                              href: this.$root.twitterLink,
                              target: "_blank",
                            },
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: "/CKFinderJava/userfiles/images/general/SOME/Twitter-social-icons-rounded-square.svg",
                                alt: "Twitter",
                              },
                            }),
                          ]
                        )
                      : _vm._e(),
                    this.$root.instagramLink != undefined &&
                    this.$root.instagramLink != ""
                      ? _c(
                          "a",
                          {
                            attrs: {
                              href: this.$root.instagramLink,
                              target: "_blank",
                            },
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: "/CKFinderJava/userfiles/images/general/SOME/glyph-logo_May2016.svg",
                                alt: "Instagram",
                              },
                            }),
                          ]
                        )
                      : _vm._e(),
                    this.$root.language.wsm_Thai_en_Footer2020_socialMedia !=
                    "false"
                      ? _c("webmessage", {
                          attrs: {
                            text: this.$root.language
                              .wsm_Thai_en_Footer2020_socialMedia,
                            searchKey: "wsm_Footer2020_socialMedia",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ])
            : _c("div", { staticClass: "footerColumnWrapper" }, [
                _c("div", [
                  !this.$root.isNutriverse
                    ? _c(
                        "h4",
                        [
                          _c("webmessage", {
                            attrs: {
                              text: this.$root.language.wsm_OpeningHours,
                              searchKey: "wsm_OpeningHours",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  this.$root.isNutriverse
                    ? _c(
                        "h4",
                        [
                          _c("webmessage", {
                            attrs: {
                              text: this.$root.language.wsm_Footer2020_about,
                              searchKey: "wsm_Footer2020_about",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  this.$root.isNutriverse
                    ? _c(
                        "p",
                        [
                          _c("webmessage", {
                            attrs: {
                              text: this.$root.language
                                .wsm_Footer2020_about_links,
                              searchKey: "wsm_Footer2020_about_links",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  !this.$root.isNutriverse
                    ? _c(
                        "p",
                        [
                          _c("webmessage", {
                            attrs: {
                              text: this.$root.language
                                .wsm_phoneOpeningHoursMonToThurs,
                              searchKey: "wsm_phoneOpeningHoursMonToThurs",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "p",
                    [
                      _c("webmessage", {
                        attrs: {
                          text: this.$root.language.wsm_phoneOpeningHoursFriday,
                          searchKey: "wsm_phoneOpeningHoursFriday",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "h2",
                    [
                      _c("webmessage", {
                        attrs: {
                          text: this.$root.language.wsm_Footer2020_phone,
                          searchKey: "wsm_Footer2020_phone",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm.isSoMeLinkAvailable
                  ? _c(
                      "div",
                      { staticClass: "soMeWrapper" },
                      [
                        this.$root.facebookLink != undefined &&
                        this.$root.facebookLink != ""
                          ? _c(
                              "a",
                              {
                                attrs: {
                                  href: this.$root.facebookLink,
                                  target: "_blank",
                                },
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: "/CKFinderJava/userfiles/images/general/SOME/Facebook.svg",
                                    alt: "Facebook/Meta",
                                  },
                                }),
                              ]
                            )
                          : _vm._e(),
                        this.$root.channel != "" &&
                        this.$root.channel != undefined
                          ? _c(
                              "a",
                              {
                                attrs: {
                                  href:
                                    "https://www.youtube.com/channel/" +
                                    this.$root.channel,
                                  target: "_blank",
                                },
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: "/CKFinderJava/userfiles/images/general/SOME/yt_icon_mono_light.svg",
                                    alt: "YouTube",
                                  },
                                }),
                              ]
                            )
                          : _vm._e(),
                        this.$root.linkedin != "" &&
                        this.$root.linkedin != undefined
                          ? _c(
                              "a",
                              {
                                attrs: {
                                  href: this.$root.linkedin,
                                  target: "_blank",
                                },
                              },
                              [
                                _c("img", {
                                  staticClass: "linkedIn",
                                  attrs: {
                                    src: "/CKFinderJava/userfiles/images/general/SOME/LI-In-Bug-black-v2.svg",
                                    alt: "LinkedIn",
                                  },
                                }),
                              ]
                            )
                          : _vm._e(),
                        this.$root.twitterLink != undefined &&
                        this.$root.twitterLink != ""
                          ? _c(
                              "a",
                              {
                                attrs: {
                                  href: this.$root.twitterLink,
                                  target: "_blank",
                                },
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: "/CKFinderJava/userfiles/images/general/SOME/Twitter-social-icons-rounded-square.svg",
                                    alt: "Twitter",
                                  },
                                }),
                              ]
                            )
                          : _vm._e(),
                        this.$root.instagramLink != undefined &&
                        this.$root.instagramLink != ""
                          ? _c(
                              "a",
                              {
                                attrs: {
                                  href: this.$root.instagramLink,
                                  target: "_blank",
                                },
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: "/CKFinderJava/userfiles/images/general/SOME/glyph-logo_May2016.svg",
                                    alt: "Instagram",
                                  },
                                }),
                              ]
                            )
                          : _vm._e(),
                        this.$root.language.wsm_Footer2020_socialMedia !=
                        "false"
                          ? _c("webmessage", {
                              attrs: {
                                text: this.$root.language
                                  .wsm_Footer2020_socialMedia,
                                searchKey: "wsm_Footer2020_socialMedia",
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
        ]),
        _c("div", { staticClass: "footerColumn fCol3" }, [
          _c("div", { staticClass: "footerColumnWrapper footerLinks" }, [
            _c("div", [
              _c(
                "h4",
                { staticClass: "flex-align-center resp-just-center" },
                [
                  _c("webmessage", {
                    attrs: {
                      text: this.$root.language.wsm_Footer2020_Links,
                      searchKey: "wsm_Footer2020_Links",
                    },
                  }),
                  _c("i", { staticClass: "fas fa-link" }),
                ],
                1
              ),
              _c(
                "p",
                { staticClass: "footer-infoLinks" },
                [
                  _c("webmessage", {
                    attrs: {
                      text: this.$root.language.wsm_Footer2016Col_3,
                      searchKey: "wsm_Footer2016Col_3",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c("div", [
              !this.$root.isMedUK
                ? _c(
                    "h4",
                    {
                      staticClass:
                        "footer-infoHeader flex-align-center resp-just-center",
                    },
                    [
                      _c("webmessage", {
                        attrs: {
                          text: this.$root.language.wsm_Footer2020_Info,
                          searchKey: "wsm_Footer2020_Info",
                        },
                      }),
                      _c("i", { staticClass: "fas fa-info" }),
                    ],
                    1
                  )
                : _vm._e(),
              !this.$root.isMedUK
                ? _c(
                    "p",
                    [
                      _c("webmessage", {
                        attrs: {
                          text: this.$root.language.wsm_Footer2016Col_2,
                          searchKey: "wsm_Footer2016Col_2",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
          ]),
        ]),
      ]),
    ]),
    _c("div", { attrs: { id: "footerSecondContainer" } }, [
      (!this.$root.isMedUK && !this.$root.isNonShop) || this.$root.isadmin
        ? _c("div", { staticClass: "footerSectionWrapper" }, [
            _c("div", { staticClass: "footerColumn" }, [
              _c("div", { staticClass: "footerColumnWrapper" }, [
                this.$root.isThai
                  ? _c(
                      "div",
                      { staticClass: "footer2020-paymentMethods" },
                      [
                        _c("webmessage", {
                          staticClass: "flex-just-center flex-wrap",
                          attrs: {
                            text: this.$root.language
                              .wsm_Thai_en_Footer2020_PaymentMethods,
                            searchKey: "wsm_Thai_en_Footer2020_PaymentMethods",
                          },
                        }),
                      ],
                      1
                    )
                  : _c(
                      "div",
                      { staticClass: "footer2020-paymentMethods" },
                      [
                        _c("webmessage", {
                          staticClass: "flex-just-center flex-wrap",
                          attrs: {
                            text: this.$root.language
                              .wsm_Footer2020_PaymentMethods,
                            searchKey: "wsm_Footer2020_PaymentMethods",
                          },
                        }),
                      ],
                      1
                    ),
              ]),
            ]),
            _c("div", { staticClass: "footerColumn" }, [
              _c("div", { staticClass: "footerColumnWrapper" }, [
                this.$root.isThai
                  ? _c(
                      "div",
                      [
                        _c("webmessage", {
                          attrs: {
                            text: this.$root.language
                              .wsm_Thai_en_Footer2020_delivery,
                            searchKey: "wsm_Thai_en_Footer2020_delivery",
                          },
                        }),
                      ],
                      1
                    )
                  : _c(
                      "div",
                      [
                        _c("webmessage", {
                          attrs: {
                            text: this.$root.language.wsm_Footer2020_delivery,
                            searchKey: "wsm_Footer2020_delivery",
                          },
                        }),
                      ],
                      1
                    ),
              ]),
            ]),
            _c("div", { staticClass: "footerColumn" }, [
              _c("div", { staticClass: "footerColumnWrapper" }, [
                _c(
                  "div",
                  { staticClass: "footer2020-extraIcons" },
                  [
                    _c("webmessage", {
                      attrs: {
                        text: this.$root.language.wsm_Footer2020_extraIcons,
                        searchKey: "wsm_Footer2020_extraIcons",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
          ])
        : _vm._e(),
      this.$root.isNonShop ? _c("div", { staticClass: "noShop" }) : _vm._e(),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("a", { staticClass: "companyLogo", attrs: { href: "/" } }, [
      _c("img", {
        staticClass: "pnLogo",
        attrs: {
          width: "238",
          height: "48",
          alt: "logo",
          loading: "lazy",
          src: "/CKFinderJava/userfiles/images/2014/general/Logo-PN-no-slogan-0514.png?w=238",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }